import React, { useEffect } from "react";
import {
    SERVICENOW_INCIDENT_ROWS_PER_PAGE,
    SERVICENOW_REQUEST_ROWS_PER_PAGE,
} from "../../../constants/generalConstants";
import PropTypes from "prop-types";
import PaginatedTable from "../../tables/paginatedTable";
import { servicenowUrl } from "../../../services/apiUtils/config/urls";
import { serviceNames, SERVICENOW } from "../../../constants/serviceNames";
import TileAccordion from "../tileAccordion";
import ServiceNowRequestRow from "./serviceNowRequestRow";
import useServiceNowRequests from "../../../services/apiUtils/hooks/useServiceNowRequests";
import { getSnUserIdFromToken } from "utils/authUtils";
import useServiceNowUser from "services/apiUtils/hooks/useServiceNowUser";

const ServiceNowRequestsSection = ({
    isEditing,
    maintenanceMode = false,
    viewClosed = false,
}) => {
    const {
        serviceNowRequests,
        serviceNowRequestsCount,
        loadingPageCount,
        setPagesToLoad,
        errorMessage,
    } = useServiceNowRequests(viewClosed);

    const { serviceNowUser, serviceNowUserIsLoading } = useServiceNowUser();

    const preloadNextPage = (newPage) => {
        if (
            newPage + 1 >= loadingPageCount &&
            serviceNowRequestsCount >
                (newPage + 1) * SERVICENOW_REQUEST_ROWS_PER_PAGE
        ) {
            void setPagesToLoad(newPage + 2);
        }
    };

    useEffect(() => {
        if (
            loadingPageCount === 1 &&
            serviceNowRequestsCount > SERVICENOW_REQUEST_ROWS_PER_PAGE
        ) {
            void setPagesToLoad(2);
        }
    }, [loadingPageCount, serviceNowRequestsCount, setPagesToLoad]);

    const snServiceNowRequestsUrl = () => {
        if (serviceNowUser && !serviceNowUserIsLoading) {
            const snUserId = getSnUserIdFromToken(serviceNowUser);
            if (snUserId) {
                const query = encodeURIComponent(
                    `requested_for=${snUserId}^ORopened_by=${snUserId}`
                );
                return `${servicenowUrl}/sc_request_list.do?sysparm_query=${query}`;
            }
        }
        return `${servicenowUrl}/sc_request_list.do`;
    };

    return (
        <TileAccordion
            serviceName={`${serviceNames[SERVICENOW]}`}
            tileName="requests"
            maintenanceMode={maintenanceMode}
            errorMessage={errorMessage}
            count={serviceNowRequestsCount}
            isEditing={isEditing}
        >
            <PaginatedTable
                totalItems={serviceNowRequestsCount}
                isEditing={isEditing}
                serviceUrl={snServiceNowRequestsUrl()}
                itemsPerPage={SERVICENOW_INCIDENT_ROWS_PER_PAGE}
                service={`${serviceNames[SERVICENOW]}`}
                items={serviceNowRequests ?? []}
                Row={ServiceNowRequestRow}
                onPageChange={preloadNextPage}
            />
        </TileAccordion>
    );
};

ServiceNowRequestsSection.propTypes = {
    isEditing: PropTypes.bool.isRequired,
    maintenanceMode: PropTypes.bool,
    viewClosed: PropTypes.bool,
};

export default ServiceNowRequestsSection;
